import React, { useEffect } from 'react';
import { X } from 'lucide-react';

// Modal fullscreen para documentos legales. Se controla por prop `open`.
// Bloquea scroll del body, cierra con ESC / botón / click fuera.
// Contenido: children (Privacidad / Terminos).
export default function LegalModal({ open, title, onClose, children, testId }) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      data-testid={testId}
      className="fixed inset-0 z-[10000] bg-slate-900/70 backdrop-blur-sm flex items-start sm:items-center justify-center p-3 sm:p-6"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[92vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-5 border-b border-slate-200 sticky top-0 bg-white rounded-t-2xl">
          <h2 className="text-lg sm:text-xl font-bold text-slate-900" data-testid={`${testId}-title`}>{title}</h2>
          <button
            type="button"
            data-testid={`${testId}-close`}
            onClick={onClose}
            className="p-2 rounded-full text-slate-500 hover:bg-slate-100"
            aria-label="Cerrar"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-5 sm:p-7 overflow-y-auto text-sm text-slate-700 leading-relaxed space-y-4">
          {children}
        </div>
      </div>
    </div>
  );
}
